import { Box, Typography, useTheme } from '@mui/material';

import SectionTitle from './components/SectionTitle';

interface Props {
  disabled?: boolean;
}

const contents = [
  '我確認醫生已向我解釋以下事項：',
  '我的病情和建議的程序，包括醫生發現意外情況時的額外治療。我了解與我相關的風險。',
  '（此程序所需的麻醉；我了解其風險。）',
  '其他相關程序／治療選項及其相關風險。',
  '我的預後以及不接受程序的風險。',
  '我了解即使此程序已由專業人士執行，也無法保證改善我的病情。',
  '（此程序可能包括輸血。）',
  '組織和血液可能被移除並用於診斷或管理我的病情，並由醫院妥善儲存和處理。',
  '如果在程序中發生立即威脅生命的事件，將根據我與醫生或我的急性復甦計畫的討論進行處理。',
  '主治醫生以外的其他醫生可能會執行此程序。我了解這可能是一位正在接受進一步訓練的醫生。',
  '我能向醫生提出關於我的病情、建議的程序及其風險以及治療選項的問題和擔憂。我的問題和擔憂\n     已被討論並得到令我滿意的解答。',
  '我了解即使在簽署此表後，我仍有權隨時改變主意，但最好是在與醫生討論後進行。',
  '我了解在程序中可能會錄製影像或視頻，這些影像或視頻將幫助醫生提供適當的治療。',
];

const GeneralPateintConsentForm = (props: Props) => {
  const { disabled } = props;
  const { palette } = useTheme();

  return (
    <>
      <SectionTitle title="一般病患同意書" />
      <Box
        sx={{
          width: '98%',
          margin: '48px auto 10px auto',
        }}
      >
        <Typography
          sx={{
            fontWeight: '400',
            fontSize: '14px',
            lineHeight: '24px',
            whiteSpace: 'pre-wrap',
          }}
        >
          我確認已閱讀並了解此治療同意書，並在簽署之前確認所有欄位已填寫完畢。
        </Typography>
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '0px auto 10px auto',
          border: '1px solid lightgray',
          padding: '10px',
        }}
      >
        {contents.map((v, i) => {
          if (i === 0) {
            return (
              <Typography
                sx={{
                  fontWeight: '400',
                  fontSize: '14px',
                  lineHeight: '24px',
                  whiteSpace: 'pre-wrap',
                }}
              >
                {v}
              </Typography>
            );
          }
          return (
            <Typography
              sx={{
                fontWeight: '400',
                fontSize: '14px',
                lineHeight: '24px',
                whiteSpace: 'pre-wrap',
              }}
            >
              • {v}
            </Typography>
          );
        })}
      </Box>

      <Box
        sx={{
          width: '98%',
          margin: '0px auto 0px auto',
        }}
      >
        <Typography
          sx={{
            fontWeight: '400',
            fontSize: '14px',
            lineHeight: '24px',
            whiteSpace: 'pre-wrap',
          }}
        >
          根據上述陳述
        </Typography>
        <br />

        <Typography
          sx={{
            fontWeight: '400',
            fontSize: '14px',
            lineHeight: '24px',
            whiteSpace: 'pre-wrap',
            color: `${palette.primary.main}`,
          }}
        >
          我已仔細閱讀並理解以上所有信息，並完全了解我正在簽署的內容。我理解我可以要求醫療人員提供更詳細的解釋。
          我特此授予治療的許可並表示同意。
        </Typography>
      </Box>
    </>
  );
};

export default GeneralPateintConsentForm;
